import { Card, Paragraph } from '@deckee/deck-hand';
import React from 'react';
import { transitionToPreviousRoute } from '../../../../../services/route/route-navigation';
import BasicDrawerLayout from '../../../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import { LayoutBody } from '../../../../layouts/components/LayoutBody/LayoutBody';

const SettingsNotificationsPage = () => (
  <BasicDrawerLayout
    heading="Notifications and alerts"
    onBack={() => transitionToPreviousRoute()}
  >
    <LayoutBody>
      <Card>
        <Card.Heading>Coming soon</Card.Heading>
        <Card.Body>
          <Paragraph>
            We're working on this! You will be able to adjust your notifications
            and alerts preferences here in a future update.
          </Paragraph>
        </Card.Body>
      </Card>
    </LayoutBody>
  </BasicDrawerLayout>
);

export default SettingsNotificationsPage;
